module.exports = __webpack_public_path__ + "assets/icon-portableCornerPosts-metalCornerPortable.4bea2380.svg";